"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constructFirebaseStorageUrl = void 0;

var constructFirebaseStorageUrl = function constructFirebaseStorageUrl() {
  var bucket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "nopanoga";
  var storageRef = arguments.length > 1 ? arguments[1] : undefined;
  return "https://firebasestorage.googleapis.com/v0/b/".concat(bucket, "/o/").concat(encodeURIComponent(storageRef), "?alt=media");
};

exports.constructFirebaseStorageUrl = constructFirebaseStorageUrl;